import { createSelector } from 'reselect'
import { selectCurrentTicket } from 'selectors/tickets'
import { selectAgentsSortedByUsername } from 'selectors/agents/base'
import { selectCurrentMailboxId } from 'selectors/mailboxes'
import { selectNewNoteDraftMailboxId } from 'ducks/drafts/selectors/noteDrafts'

export const selectAccessLists = state => state.app.accessLists || []

const selectCurrentMailboxAccessList = createSelector(
  selectAccessLists,
  selectCurrentTicket,
  selectCurrentMailboxId,
  (accessLists, ticket, listMailboxId) => {
    const mailboxId = ticket ? ticket.mailboxId : listMailboxId
    if (!mailboxId) return null
    // find access list for a specific mailbox
    return accessLists.find(list => list.mailboxId === mailboxId.toString())
  }
)
const selectNewNoteDraftMailboxAccessList = createSelector(
  selectAccessLists,
  selectNewNoteDraftMailboxId,
  (accessLists, mailboxId) => {
    if (!mailboxId) return null
    // find access list for a specific mailbox
    return accessLists.find(list => list.mailboxId === mailboxId.toString())
  }
)
const selectGlobalMailboxAccessList = createSelector(
  selectAccessLists,
  selectCurrentMailboxId,
  (accessLists, listMailboxId) => {
    // find access list for a specific mailbox
    if (!accessLists) return []
    return accessLists.find(list => list.mailboxId === listMailboxId)
  }
)

export const selectCurrentMailboxAgents = createSelector(
  selectAgentsSortedByUsername,
  selectCurrentMailboxAccessList,
  (agents, accessList) => {
    if (accessList && accessList.agentIds.length > 0) {
      return agents.filter(agent => accessList.agentIds.indexOf(agent.id) > -1)
    }
    return agents
  }
)

export const selectNewNoteDraftMailboxAgents = createSelector(
  selectAgentsSortedByUsername,
  selectNewNoteDraftMailboxAccessList,
  (agents, accessList) => {
    if (accessList && accessList.agentIds.length > 0) {
      return agents.filter(agent => accessList.agentIds.indexOf(agent.id) > -1)
    }
    return agents
  }
)

export const selectGlobalMailboxAgents = createSelector(
  selectAgentsSortedByUsername,
  selectGlobalMailboxAccessList,
  (agents, accessList) => {
    if (accessList && accessList.agentIds.length > 0) {
      return agents.filter(agent => accessList.agentIds.indexOf(agent.id) > -1)
    }
    return agents
  }
)
